export const MenuItems = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        icon: 'bx bx-home-circle',
        role:["SUPER_ADMIN","ADMIN","CLIENT"]
    },
    {
        name: 'Bookings',
        path: '/bookings',
        icon: 'mdi mdi-clipboard-check-outline',
        role:[ "SUPER_ADMIN", "ADMIN","CLIENT"]
    },
    {
        name: 'Clients',
        path: '/clients',
        icon: 'mdi mdi-account-group-outline',
        role:["SUPER_ADMIN","ADMIN"]
    },
    {
        name: 'Users',
        path: '/users',
        icon: 'mdi mdi-account-details-outline',
        role:["SUPER_ADMIN","ADMIN"]
    },
    {
        name: 'Admins',
        path: '/admin',
        icon: 'mdi mdi-account-cog-outline',
        role:["SUPER_ADMIN"]
    },
    {
        name: 'Enquiries',
        path: '/enquiries',
        icon: 'mdi mdi-comment-text-outline',
        role:["SUPER_ADMIN", "ADMIN","CLIENT"]
    },
    // {
    //     name: 'Report',
    //     path: '/report',
    //     icon: 'mdi mdi-clipboard-text-outline',
    //     role:["SUPER_ADMIN", "ADMIN","CLIENT"]
    // },
    {
        name: 'Settings',
        path: '/settings',
        icon: 'mdi mdi-clipboard-text-outline',
        role:["SUPER_ADMIN"]
    }
]